import { defaultStyles } from 'react-modal'

const { content, overlay } = defaultStyles

const axis = {
  legendPosition: 'middle',
  tickRotation: 0,
  tickSize: 0
}

const colors = { dark: '#13131A' }

const margin = { top: 15, right: 15, bottom: 15, left: 35 }

export const settings = {
  margin,
  arcLinkLabelsDiagonalLength: 5,
  arcLinkLabelsStraightLength: 5,
  areaOpacity: 0.07,
  // axisBottom: false,
  axisBottom: null,
  axisLeft: { ...axis, orient: 'left' },
  colors: ['#D19E6B'],
  // colors: ['#6B9ED1'],
  // colors: ['#6B6BD1'],
  // colors: ['#C16B6B'],
  enableArcLinkLabels: false,
  enableArea: true,
  enableCrosshair: false,
  enableGridX: false,
  enableGridY: false,
  enableLabel: false,
  enablePoints: false,
  fit: true,
  innerPadding: 2,
  innerRadius: 0.45,
  min: 0,
  padAngle: 1,
  sortByValue: true,
  useMesh: true
}

export const modal = {
  content: {
    ...content,
    background: colors.dark,
    border: 'none',
    boxShadow: '0 3px 10px rgb(255, 255, 255, 0.2)',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'none',
    position: ''
  },
  overlay: {
    ...overlay,
    alignItems: 'center',
    background: 'rgba(19, 19, 26, 0.75)',
    display: 'flex',
    justifyContent: 'center',
    zIndex: '20'
  }
}
